<template>
  <v-os-popup
    class="refund-reason-popup"
    :title="`请选择${titleType[type]}原因（必选）`"
    v-model="show"
    @close="close"
    :backFnDisable="true"
  >
    <div class="content">
      <div class="prompt-block" v-if="type == 'refund'">
        <div class="block-item d-f ai-c jc-sb">
          <div class="block-left">
            <span class="title">退款金额</span>
            <span class="des">（以实际到账为准）</span>
          </div>
          <div class="block-right">￥{{ actPaidAmount | formatMoney }}</div>
        </div>
        <div class="block-item d-f ai-c jc-sb" v-if="pointsUse">
          <div class="block-left">
            <span class="title">退回抵现积分</span>
            <span class="des">（以实际到账为准）</span>
          </div>
          <div class="block-right">{{ pointsUse }}</div>
        </div>
      </div>
      <v-text-expand ref="textExpand" :text="promptText"></v-text-expand>
      <div v-for="(item, index) in reasonList" :key="index">
        <div class="item d-f ai-c jc-sb" @click="changeSelectValue(index, item.cancelReason)">
          <div class="reason" v-text="item.cancelReason"></div>
          <!-- <div class="c-radio" :class="{ selected: selectedIndex == index }"></div> -->
          <div class="c-radio2">
            <v-checkbox :value="selectedIndex == index"></v-checkbox>
          </div>
        </div>
        <div class="sub-item d-f ai-c jc-sb" v-if="item.operate && selectedIndex == index">
          <div class="desc lc-1">{{ item.toast }}</div>
          <div class="btn" @click="link(item.operate)" v-track="trackParam(item)">
            <span>{{ operateType[item.operate] }}</span>
            <v-icon class="icon-right" name="arrow-right-v3" color="#F10313"></v-icon>
          </div>
        </div>
      </div>
      <!-- 退货时不展示补充描述 -->
      <nx-input-item
        ref="reasonInputRef"
        v-if="showReasonInput"
        placeholder="补充描述，有助于我们为您更好的处理售后问题"
        v-model="otherReason"
        maxlength="100"
        multiline
      ></nx-input-item>
    </div>
    <div class="footer border1px" slot="footer">
      <!-- TODO:只有普通订单才展示加入购物车选项 -->
      <div class="add-shopcart d-f ai-c jc-sb" v-if="showAddCartOption && !isWeChatApp">
        <div class="des">提交后，将本单商品放回购物车</div>
        <nx-switch v-model="addShoppingCart" activeColor="#ffbfc566" circleColor="#e90f23"></nx-switch>
      </div>
      <!-- <div class="btn" @click="confirm" v-text="type == 'returnGoods' ? '提交' : '确认'"></div> -->
      <v-button size="large" @click="confirm">
        {{ type == 'returnGoods' ? '提交' : '确认' }}
      </v-button>
    </div>
  </v-os-popup>
</template>

<script>
import API from 'api'
import { getCancelReq } from '../../api'
import { submitRefundReq, refundSubmit } from '../../../refund/api'
import env from '@/utils/clientEnv'
import { addCommodityReq } from '@/views/product/detail/index/api'
import { InputItem } from '@vivo/vos-ui'

const Prompts = {
  cancel: {
    normal: '订单取消后无法恢复，已用抵现积分、优惠券将原路返还',
    isRenewOrder: '订单取消后无法恢复，已用抵现积分、优惠券将原路返还。若为一站式换新【上门送新机，同时回收旧机】的订单，则新机和旧机订单将一同取消。'
  },
  refund: {
    normal: '订单退款成功后，已付金额、换新鼓励金、抵现积分、优惠券将原路返还',
    isRenewOrder: '订单退款成功后，已付金额、换新鼓励金、抵现积分、优惠券将原路返还。若为以旧换新订单：<br/>（1）仅新机订单退款，则换新补贴将同步取消并扣除；旧机完成检测后，回收款由回收商发放；<br/>（2）仅旧机订单取消，则换新补贴将同步取消并扣除，其中旧机由回收商退回。'
  },
  returnGoods: {
    normal: '订单部分退货成功后，已付金额、换新鼓励金、抵现积分将原路返还，优惠券不做退还。订单全部退货成功后，已付金额、换新鼓励金、抵现积分、代金券、免邮券、免息券、优惠券将原路返还',
    isRenewOrder: '订单退货成功后，已付金额、换新鼓励金、抵现积分将原路返还，优惠券不予退还。若为以旧换新订单：<br/>（1）仅新机订单退货，则换新补贴将同步取消并扣除；旧机完成检测后，回收款由回收商发放；<br/>（2）仅旧机订单取消，则换新补贴将同步取消并扣除，其中旧机由回收商退回'
  }
}
export default {
  name: 'OrderRefundPopup',
  props: {},
  components: {
    [InputItem.name]: InputItem
  },
  data: function () {
    return {
      operateType: { 1: '联系客服', 2: '立即修改', 3: '申请价保' },
      titleType: { cancel: '取消', refund: '退款', returnGoods: '退货' },
      addShoppingCart: false,
      otherReason: '',
      show: false,
      type: 'cancel', // cancel or refund or returnGoods
      reasonList: [],
      orderNo: null,
      selectedIndex: -1,
      selectedReason: '',
      showAddCartOption: false,
      orderCommodityUnits: [],
      fullPath: '',
      routerFun: null,
      orderType: '01',
      orderBase: {},
      isWeChatApp: false,
      isList: false, // 表示该弹窗是否为订单列表页打开
      disabledModifyAdress: false,
      mutiRows: false,
      expanded: false,
      promptText: ''
    }
  },
  watch: {
    show() {
      if (this.show === false) {
        this.selectedIndex = -1
        this.selectedReason = ''
        this.$refs.textExpand.showTotal = false
      } else {
        let tips = Prompts[this.type] || {}
        if (this.orderRenewVO) {
          this.promptText = tips[this.tipsType] || ''
        } else {
          this.promptText = tips.normal || ''
        }
      }
    },
    showReasonInput(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.reasonInputRef?.$el?.scrollIntoView(true)
        })
      }
    }
  },
  computed: {
    hideTransition() {
      if (this.selectedIndex != -1) {
        return true
      } else {
        return false
      }
    },
    // 是否是门店订单
    isDelivery() {
      let deliveryMode = this.orderBase?.offlineOrderInfo?.deliveryMode
      return deliveryMode === 1 || deliveryMode === 2 || deliveryMode === 3 || deliveryMode === 4
    },
    // 是否为拼团订单
    isGroup() {
      return this.orderBase.grouponStatus != 0
    },
    // 实付金额（加换新鼓励金）
    actPaidAmount() {
      return this.orderBase.cashCoupon
        ? this.orderBase.actPaidAmount + this.orderBase.cashCoupon
        : this.orderBase.actPaidAmount
    },
    // 退回积分
    pointsUse() {
      return this.orderBase?.pointsUse
    },
    // 展示其他输入框
    showReasonInput() {
      return this.selectedIndex == this.reasonList.length - 1 && this.type != 'returnGoods'
    },
    tipsType() {
      if (this.type == 'cancel') {
        if (this.orderRenewVO?.recycleRenewType == 2) {
          return 'isRenewOrder'
        } else {
          return 'normal'
        }
      } else {
        return 'isRenewOrder'
      }
    }
  },
  methods: {
    changeSelectValue(index, reason) {
      if (this.selectedIndex == index) {
        this.selectedIndex = -1
        this.selectedReason = ''
      } else {
        this.selectedIndex = index
        this.addShoppingCart = this.showAddCartOption
        this.selectedReason = reason
      }
    },
    link(type) {
      // 联系客服
      // TODO:这里类型需要调整
      if (type == 1) {
        window.location.href =
          'https://kefu.vivo.com.cn/robot-vivo/mobileChat.html?f=mall&forVivoSpace=share.mp.qq.com/cgi/share.php'
        this.close()
      } else if (type == 2) {
        // TODO
        // 校验订单是否为门店闪送
        if (this.isDelivery) {
          this.$toast('该订单不支持修改收货地址')
          // 网易/iot订单
        } else if (this.disabledModifyAdress) {
          this.$toast('请联系客服修改地址')
        } else {
          // 打开修改地址界面
          this.dealAddress()
        }
      } else {
        // 申请价保
        // TODO 需要确定参数
        this.routerFun('push', {
          path: '/my/jiabao?orderNo=' + this.orderNo
        })
        this.close()
      }
    },
    trackParam(item) {
      if (this.isList) {
        // 订单列表页
        return [
          {
            act: 'show',
            params: {
              cfrom: '101|011|02|077',
              event_id: '101|011|02|077',
              button: this.operateType[item.operate]
            }
          },
          {
            act: 'click',
            params: {
              cfrom: '101|011|01|077',
              event_id: '101|011|01|077',
              button: this.operateType[item.operate]
            }
          }
        ]
      } else {
        // 详情页
        if (this.type == 'cancel') {
          // 取消弹层
          return [
            {
              act: 'show',
              params: {
                cfrom: '084|010|02|077',
                event_id: '084|010|02|077',
                button: this.operateType[item.operate],
                is_change: this.orderRenewVO ? '1' : '0'
              }
            },
            {
              act: 'click',
              params: {
                cfrom: '084|010|01|077',
                event_id: '084|010|01|077',
                button: this.operateType[item.operate],
                is_change: this.orderRenewVO ? '1' : '0'
              }
            }
          ]
        } else if (this.type == 'refund') {
          // 退款弹层
          return [
            {
              act: 'show',
              params: {
                cfrom: '084|014|02|077',
                event_id: '084|014|02|077',
                button: this.operateType[item.operate],
                is_change: this.orderRenewVO ? '1' : '0'
              }
            },
            {
              act: 'click',
              params: {
                cfrom: '084|014|01|077',
                event_id: '084|014|01|077',
                button: this.operateType[item.operate],
                is_change: this.orderRenewVO ? '1' : '0'
              }
            }
          ]
        } else if (this.type == 'returnGoods') {
          // 退货弹层
          return [
            {
              act: 'show',
              params: {
                cfrom: '224|005|02|077',
                event_id: '224|005|02|077',
                button: this.operateType[item.operate],
                is_change: this.orderRenewVO ? '1' : '0'
              }
            },
            {
              act: 'click',
              params: {
                cfrom: '224|005|01|077',
                event_id: '224|005|01|077',
                button: this.operateType[item.operate],
                is_change: this.orderRenewVO ? '1' : '0'
              }
            }
          ]
        }
      }
      return undefined
    },
    // 修改地址
    dealAddress() {
      const { orderNo } = this
      let url = this.fullPath
      let param = ''
      if (url.indexOf('addressId') === -1) {
        param = `&orderNo=${orderNo}`
      } else {
        param = `&orderNo=${orderNo}&addressId=${this.$route.query.addressId}`
      }
      let backUrl = encodeURIComponent(url) + param
      // this.$router不生效
      this.routerFun('push', { path: '/my/address?backUrl=' + backUrl })
      this.close()
    },
    confirm() {
      if (this.type == 'cancel') {
        this.orderCancel()
      } else if (this.type == 'refund') {
        this.orderRefund()
      } else {
        // 退货处理逻辑
        this.orderEv(this.selectedIndex, this.addShoppingCart)
      }
    },
    close() {
      this.show = false
    },
    // 订单取消
    orderCancel() {
      const { selectedIndex, orderNo, otherReason } = this
      if (selectedIndex == -1) {
        this.$toast('请选择取消原因')
      } else if (selectedIndex == this.reasonList.length - 1 && otherReason.trim() == '') {
        this.$toast('请填写补充描述')
      } else {
        getCancelReq({
          cancelType: this.reasonList[selectedIndex].cancelType,
          cancelReason: this.selectedReason,
          cancelDesc: otherReason.trim(),
          orderNo,
          tempTerminal: this.tempTerminal
        })
          .then(data => {
            if (this.orderType === '02') {
              this.$toast('取消订单成功,请等待客服审核')
            } else {
              this.$toast('取消订单成功')
            }
            this.addShooping()
            this.orderEv(orderNo)
            this.close()
          })
          .catch(err => {
            this.$toast(err.msg || '取消订单失败，请稍后重试')
          })
      }
    },
    // 订单退款
    orderRefund() {
      const { selectedIndex, orderNo, otherReason } = this
      if (selectedIndex == -1) {
        this.$toast('请选择退款原因')
      } else if (selectedIndex == this.reasonList.length - 1 && otherReason.trim() == '') {
        this.$toast('请填写补充描述')
      } else {
        let params = {
          orderNo: orderNo,
          refundType: 1, //退款
          refundReason: this.selectedReason,
          refundDesc: otherReason.trim(),
          tempTerminal: this.tempTerminal
        }
        refundSubmit(params).then(
          res => {
            this.addShooping()
            this.close()
            this.$osDialog.alert({
              content: res.applyResult,
              confirmStyles: {
                color: '#e90f23'
              },
              onConfirm: () => {
                this.routerFun('replace', {
                  name: 'refundDetail',
                  query: {
                    orderNo: this.orderNo,
                    refundNo: res.refundNo,
                    tempTerminal: this.tempTerminal,
                    from: 'order-refund-popup'
                  }
                })
              },
            })
          },
          res => {
            if (res && res.code === '80003') {
              this.$osDialog.alert({
                content: res.msg,
                confirmText: '查看详情',
                confirmStyles: {
                  color: '#e90f23'
                },
                onConfirm: () => {
                  this.routerFun('replace', {
                    name: 'refundDetail',
                    query: { orderNo: this.orderNo, tempTerminal: this.tempTerminal, from: 'order-refund-popup' }
                  })
                  this.close()
                }
              })
            } else if (res && res.msg) {
              this.$toast(res.msg)
            }
          }
        )
      }
    },
    // 添加购物车,这里对于存在多个主商品，需要循环调用添加购物车接口，注意添加购物车失败不做处理
    async addShooping() {
      // 判断添加购物车，
      if (this.addShoppingCart) {
        for (let i = 0; i < this.orderCommodityUnits.length; i++) {
          const el = this.orderCommodityUnits[i]
          let param = {
            num: el.orderCommodity.num,
            mainSku: {
              skuId: el.orderCommodity.commoditySkuId,
            }
          }
          // 套餐信息
          if (el.orderCommoditySuite?.suiteCode) {
            param.suiteCode = el.orderCommoditySuite.suiteCode
          }

          // 附属商品信息
          param.bundleSkuList = []
          el.bundledList?.forEach(ele => {
            const { commoditySkuId: skuId, commoditySpuId: spuId, salePrice } = ele
            param.bundleSkuList.push({ skuId, spuId, salePrice })
          })
          // 服务信息
          param.serviceSkuList = []
          el.serviceList?.forEach(ele => {
            const { commoditySkuId: skuId, commoditySpuId: spuId, salePrice } = ele
            param.serviceSkuList.push({ skuId, spuId, salePrice })
          })
          await addCommodityReq(param)
        }
      }
    },
    // 校验是否是微信小程序
    async checkWechat() {
      this.isWeChatApp = await env.checkWeChat()
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
